// extracted by mini-css-extract-plugin
module.exports = {"FormWrapper":"FormWrapper___3afUd","QrCodeItemWrapper":"QrCodeItemWrapper___3fcgl","TableWrapper":"TableWrapper___2VwmS","ModalWrapper":"ModalWrapper___3L-FV"};